// // import React from "react";
// // import CountUp from "react-countup";
// // import ab1 from "../Images/ab1.jpeg";
// // import ab2 from "../Images/ab2.jpg";
// // import ab4 from "../Images/ab4.jpeg";
// // import "./AboutSection.css";

// // export default function AboutSection() {
// //   return (
// //     <section className="about-luxury">
// //       <div className="background-split">
// //         <div className="bg-left"></div>
// //         <div className="bg-right"></div>
// //       </div>

// //       <div className="overlay"></div>

// //       <div className="about-inner luxury-content">
        
// //         <p className="about-intro" data-aos="fade-up">
// //           Infosight is{" "}
// //           <span className="highlight">redefining</span> the future of building
// //           technologies — from <span className="highlight">IBMS</span> to{" "}
// //           <span className="highlight">Acoustics</span>, with over{" "}
// //           <span className="highlight">300+</span> iconic projects across the GCC.
// //         </p>

// //         <div className="about-stats" data-aos="fade-up" data-aos-delay="200">
// //           <div className="stat-card">
// //             <div className="stat-number">
// //               <CountUp end={300} duration={2.5} />+
// //             </div>
// //             <div className="stat-label">Projects</div>
// //           </div>
// //           <div className="stat-card">
// //             <div className="stat-number">
// //               <CountUp end={150} duration={2.5} />+
// //             </div>
// //             <div className="stat-label">Hotels</div>
// //           </div>
// //           <div className="stat-card">
// //             <div className="stat-number">
// //               <CountUp end={20} duration={2.5} />+
// //             </div>
// //             <div className="stat-label">Govt. / Corporate</div>
// //           </div>
// //           <div className="stat-card">
// //             <div className="stat-number">
// //               <CountUp end={500} duration={3} />+
// //             </div>
// //             <div className="stat-label">Bed Hospital Design</div>
// //           </div>
// //         </div>
// //       </div>

  
// //     </section>
// //   );
// // }


// import React, { useEffect, useState } from "react";
// import CountUp from "react-countup";
// import "./AboutSection.css";

// export default function AboutSection() {
//   const [stats, setStats] = useState([]);

//   // Fetch Status Cards
//   useEffect(() => {
//     async function fetchStats() {
//       try {
//         const res = await fetch("https://api.info-sight.net/api/status-cards");
//         const data = await res.json();
//         setStats(data);
//       } catch (err) {
//         console.error("Failed to fetch status cards:", err);
//       }
//     }

//     fetchStats();
//   }, []);

//   return (
//     <section className="about-luxury">
//       <div className="background-split">
//         <div className="bg-left"></div>
//         <div className="bg-right"></div>
//       </div>

//       <div className="overlay"></div>

//       <div className="about-inner luxury-content">
//         {/* <p className="about-intro" data-aos="fade-up">
//           Infosight is{" "}
//           <span className="highlight">redefining</span> the future of building
//           technologies — from <span className="highlight">IBMS</span> to{" "}
//           <span className="highlight">Acoustics</span>, with over{" "}
//           <span className="highlight">300+</span> iconic projects across the GCC.
//         </p> */}

//         <p className="about-intro" data-aos="fade-up">
//   Infosight is a{" "}
//   <span className="highlight">trusted design Consulting Firm </span> delivering
//   specialized expertise across{" "}
//   <span className="highlight">
//     {/* Acoustics, IBMS, AV, IT/ICT, Security & SRA */}
//     Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability & Green Building, Project Management
//   </span>
//   . Serving Hospitality, Mixed Used, Corporate, Government, we
//   deliver{" "}
//   <span className="highlight">precision-engineered</span>, scalable, and
//   future-ready solutions.
// </p>
//   <div className="about-stats" data-aos="fade-up" data-aos-delay="200">
//           {stats.filter(item => item.id === 1).map((item) => (
//             <div className="stat-card" key={item.id}>
//               <div className="stat-number">
//                 <CountUp end={item.count} duration={2.5} />+
//               </div>
//               <div className="stat-label">{item.name}</div>
//             </div>
//           ))}
//         </div>

//         <div className="about-stats" data-aos="fade-up" data-aos-delay="200">
//           {stats.filter(item => item.id !== 1).map((item) => (
//             <div className="stat-card" key={item.id}>
//               <div className="stat-number">
//                 <CountUp end={item.count} duration={2.5} />+
//               </div>
//               <div className="stat-label">{item.name}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }


// import React, { useEffect, useState } from "react";
// import CountUp from "react-countup";
// import {
//   FaBuilding,
//   FaHotel,
//   FaHospital,
//   FaCity,
//   FaCheckCircle,
//   FaChartLine,
// } from "react-icons/fa";

// // Eye-Comfort Real Estate & Tech Palette
// const theme = {
//   bgSection: "#F8FAF9",
//   bgCard: "#FFFFFF",
//   bgSubtle: "#F1F5F9",
//   primary: "#0F172A", // Slate Navy
//   accent: "#0D9488", // Soft Emerald Teal
//   accentLight: "#CCFBF1",
//   textDark: "#1E293B",
//   textMuted: "#64748B",
//   border: "#E2E8F0",
//   shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
//   shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
// };

// // Global Responsive Injection for CSS
// const inlineStyles = `
//   .about-section-wrapper {
//     background-color: ${theme.bgSection};
//     padding: 80px 20px;
//     font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//   }
//   .about-card-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
//     gap: 24px;
//     margin-top: 40px;
//   }
//   .stat-card-item {
//     background-color: ${theme.bgCard};
//     border: 1px solid ${theme.border};
//     border-radius: 16px;
//     padding: 28px 20px;
//     text-align: center;
//     box-shadow: ${theme.shadowSm};
//     transition: transform 0.3s ease, box-shadow 0.3s ease;
//   }
//   .stat-card-item:hover {
//     transform: translateY(-6px);
//     box-shadow: ${theme.shadowMd};
//     border-color: ${theme.accent};
//   }
//   @media (max-width: 768px) {
//     .about-section-wrapper {
//       padding: 50px 16px;
//     }
//     .about-card-grid {
//       grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
//       gap: 16px;
//     }
//   }
// `;

// export default function AboutSection() {
//   const [stats, setStats] = useState([]);

//   // Dynamic Icon Selection Helper
//   const getStatIcon = (name) => {
//     const label = (name || "").toLowerCase();
//     if (label.includes("hotel") || label.includes("hospitality")) return <FaHotel size={28} color={theme.accent} />;
//     if (label.includes("hospital") || label.includes("bed")) return <FaHospital size={28} color={theme.accent} />;
//     if (label.includes("govt") || label.includes("corporate") || label.includes("office")) return <FaCity size={28} color={theme.accent} />;
//     if (label.includes("project")) return <FaBuilding size={28} color={theme.accent} />;
//     return <FaChartLine size={28} color={theme.accent} />;
//   };

//   useEffect(() => {
//     async function fetchStats() {
//       try {
//         const res = await fetch("https://api.info-sight.net/api/status-cards");
//         const data = await res.json();
//         setStats(data);
//       } catch (err) {
//         console.error("Failed to fetch status cards:", err);
//       }
//     }

//     fetchStats();
//   }, []);

//   return (
//     <>
//       <style>{inlineStyles}</style>
//       <section className="about-section-wrapper">
//         <div style={{ maxWidth: "1140px", margin: "0 auto" }}>
          
//           {/* Section Introduction */}
//           <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }} data-aos="fade-up">
//             <span
//               style={{
//                 color: theme.accent,
//                 fontWeight: "600",
//                 fontSize: "0.875rem",
//                 letterSpacing: "1.2px",
//                 textTransform: "uppercase",
//                 backgroundColor: theme.accentLight,
//                 padding: "6px 16px",
//                 borderRadius: "20px",
//                 display: "inline-block",
//                 marginBottom: "12px",
//               }}
//             >
//               Who We Are
//             </span>
            
//             <h2
//               style={{
//                 fontSize: "2.25rem",
//                 fontWeight: "700",
//                 color: theme.primary,
//                 lineHeight: "1.3",
//                 marginBottom: "20px",
//               }}
//             >
//               Trusted Design & Engineering Consulting
//             </h2>

//             <p
//               style={{
//                 fontSize: "1.05rem",
//                 color: theme.textMuted,
//                 lineHeight: "1.7",
//               }}
//             >
//               Infosight is a trusted design Consulting Firm delivering specialized expertise across{" "}
//               <strong style={{ color: theme.textDark, fontWeight: "600" }}>
//                 Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability & Green Building, and Project Management
//               </strong>
//               . Serving Hospitality, Mixed Use, Corporate, and Government sectors, we deliver precision-engineered, scalable, and future-ready solutions.
//             </p>
//           </div>

//           {/* Metrics & Statistics Cards Grid */}
//           <div className="about-card-grid" data-aos="fade-up" data-aos-delay="200">
//             {stats.length > 0 ? (
//               stats.map((item) => (
//                 <div className="stat-card-item" key={item.id}>
//                   <div
//                     style={{
//                       width: "60px",
//                       height: "60px",
//                       borderRadius: "50%",
//                       backgroundColor: theme.bgSubtle,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       margin: "0 auto 16px",
//                     }}
//                   >
//                     {getStatIcon(item.name)}
//                   </div>
                  
//                   <div
//                     style={{
//                       fontSize: "2rem",
//                       fontWeight: "800",
//                       color: theme.primary,
//                       marginBottom: "6px",
//                     }}
//                   >
//                     <CountUp end={Number(item.count) || 0} duration={2.5} />+
//                   </div>

//                   <div
//                     style={{
//                       fontSize: "0.9rem",
//                       fontWeight: "600",
//                       color: theme.textMuted,
//                       textTransform: "capitalize",
//                     }}
//                   >
//                     {item.name}
//                   </div>
//                 </div>
//               ))
//             ) : (
//               // Fallback Metrics if API is empty or loading
//               [
//                 { id: 1, name: "Projects Delivered", count: 300 },
//                 { id: 2, name: "Hotels & Hospitality", count: 150 },
//                 { id: 3, name: "Govt. & Corporate", count: 20 },
//                 { id: 4, name: "Beds Healthcare", count: 500 },
//               ].map((item) => (
//                 <div className="stat-card-item" key={item.id}>
//                   <div
//                     style={{
//                       width: "60px",
//                       height: "60px",
//                       borderRadius: "50%",
//                       backgroundColor: theme.bgSubtle,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       margin: "0 auto 16px",
//                     }}
//                   >
//                     {getStatIcon(item.name)}
//                   </div>

//                   <div
//                     style={{
//                       fontSize: "2rem",
//                       fontWeight: "800",
//                       color: theme.primary,
//                       marginBottom: "6px",
//                     }}
//                   >
//                     <CountUp end={item.count} duration={2.5} />+
//                   </div>

//                   <div
//                     style={{
//                       fontSize: "0.9rem",
//                       fontWeight: "600",
//                       color: theme.textMuted,
//                     }}
//                   >
//                     {item.name}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>

//         </div>
//       </section>
//     </>
//   );
// }


import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import {
  FaBuilding,
  FaHotel,
  FaHospital,
  FaCity,
  FaCheckCircle,
  FaChartLine,
  FaShieldAlt,
  FaVolumeUp,
  FaMicrochip,
  FaProjectDiagram,
} from "react-icons/fa";

// Eye-Comfort High-End Real Estate & Architectural Palette
const theme = {
  bgSection: "#F8FAF9",
  bgHeroCard: "#0F172A", // Deep Slate Navy
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A",
  accent: "#0D9488", // Emerald Teal
  accentLight: "#CCFBF1",
  gold: "#D97706", // Muted Architectural Gold
  goldLight: "#FEF3C7",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 2px 4px rgba(0, 0, 0, 0.04)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

// Global Responsive Injection
const inlineStyles = `
  .about-rich-section {
    background-color: ${theme.bgSection};
    padding: 80px 20px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .about-hero-card {
    background: linear-gradient(135deg, ${theme.bgHeroCard} 0%, #1E293B 100%);
    border-radius: 24px;
    padding: 50px 40px;
    color: #FFFFFF;
    box-shadow: ${theme.shadowLg};
    position: relative;
    overflow: hidden;
    margin-bottom: 50px;
  }

  .about-hero-card::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(13, 148, 136, 0.15) 0%, transparent 70%);
    pointer-events: none;
  }

  .pillars-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-top: 30px;
  }

  .pillar-item {
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: transform 0.2s ease, background 0.2s ease;
  }

  .pillar-item:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: translateY(-2px);
  }

  /* Metrics Cards Grid */
  .about-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 24px;
  }

  .rich-stat-card {
    background-color: ${theme.bgCard};
    border: 1px solid ${theme.border};
    border-radius: 20px;
    padding: 32px 24px;
    text-align: center;
    box-shadow: ${theme.shadowSm};
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    position: relative;
  }

  .rich-stat-card:hover {
    transform: translateY(-8px);
    box-shadow: ${theme.shadowMd};
    border-color: ${theme.accent};
  }

  .stat-icon-container {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: ${theme.bgSubtle};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    transition: background-color 0.3s ease;
  }

  .rich-stat-card:hover .stat-icon-container {
    background-color: ${theme.accentLight};
  }

  @media (max-width: 768px) {
    .about-rich-section {
      padding: 50px 16px;
    }
    .about-hero-card {
      padding: 32px 20px;
      border-radius: 16px;
    }
    .pillars-grid {
      grid-template-columns: 1fr;
    }
    .about-stats-grid {
      grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
      gap: 16px;
    }
  }
`;

export default function AboutSection() {
  const [stats, setStats] = useState([]);

  // Helper for dynamic stat icons
  const getStatIcon = (name) => {
    const label = (name || "").toLowerCase();
    if (label.includes("hotel") || label.includes("hospitality"))
      return <FaHotel size={28} color={theme.accent} />;
    if (label.includes("hospital") || label.includes("bed"))
      return <FaHospital size={28} color={theme.accent} />;
    if (
      label.includes("govt") ||
      label.includes("corporate") ||
      label.includes("office")
    )
      return <FaCity size={28} color={theme.accent} />;
    if (label.includes("project"))
      return <FaBuilding size={28} color={theme.accent} />;
    return <FaChartLine size={28} color={theme.accent} />;
  };

  useEffect(() => {
    async function fetchStats() {
      try {
        const res = await fetch("https://api.info-sight.net/api/status-cards");
        const data = await res.json();
        setStats(data);
      } catch (err) {
        console.error("Failed to fetch status cards:", err);
      }
    }

    fetchStats();
  }, []);

  const corePillars = [
    { title: "Building Acoustics", icon: <FaVolumeUp color={theme.accentLight} /> },
    { title: "Smart IBMS & AV", icon: <FaMicrochip color={theme.accentLight} /> },
    { title: "Security Risk (SRA)", icon: <FaShieldAlt color={theme.accentLight} /> },
    { title: "Project Management", icon: <FaProjectDiagram color={theme.accentLight} /> },
  ];

  const defaultStats = [
    { id: 1, name: "Projects Delivered", count: 400 },
    { id: 2, name: "Hotels & Hospitality", count: 200 },
    { id: 3, name: "Govt. & Corporate", count: 20 },
    { id: 4, name: "Beds Healthcare", count: 500 },
  ];

  const displayStats = stats.length > 0 ? stats : defaultStats;

  return (
    <>
      <style>{inlineStyles}</style>
      <section className="about-rich-section">
        <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
          
          {/* Main Hero Overview Banner */}
          <div className="about-hero-card" data-aos="fade-up">
            <span
              style={{
                color: theme.accentLight,
                fontWeight: "600",
                fontSize: "0.85rem",
                letterSpacing: "1.2px",
                textTransform: "uppercase",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                padding: "6px 16px",
                borderRadius: "20px",
                display: "inline-block",
                marginBottom: "16px",
              }}
            >
              Who We Are
            </span>

            <h2
              style={{
                fontSize: "1.9rem",
                fontWeight: "800",
                lineHeight: "1.25",
                marginBottom: "16px",
                color: "#FFFFFF",
              }}
            >
              {/* Architectural & Smart Building Consulting Firm */}
The Premier Nexus of Acoustics, ICT, Security, and Precision Engineering
            </h2>

            <p
              style={{
                fontSize: "1.05rem",
                color: "rgba(255, 255, 255, 0.82)",
                lineHeight: "1.7",
                maxWidth: "920px",
                margin: "0 0 24px 0",
              }}
            >
              Infosight is a premier design consultancy delivering precision engineering across{" "}
              <strong style={{ color: "#FFFFFF", fontWeight: "600" }}>
                Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability, and Project Management
              </strong>
              . Serving iconic Hospitality, Mixed-Use, Corporate, and Government landmarks, we deliver scalable and future-ready solutions.
            </p>

            {/* Core Pillars Grid */}
            <div className="pillars-grid">
              {corePillars.map((pillar, index) => (
                <div key={index} className="pillar-item">
                  <div style={{ fontSize: "1.1rem", display: "flex" }}>{pillar.icon}</div>
                  <span style={{ fontSize: "0.9rem", fontWeight: "600", color: "#FFFFFF" }}>
                    {pillar.title}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Section Subheader */}
          <div style={{ textAlign: "center", marginBottom: "36px" }} data-aos="fade-up">
            <h3 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary }}>
              Proven Track Record of Excellence
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.95rem", marginTop: "4px" }}>
              Key performance milestones achieved across global development projects
            </p>
          </div>

          {/* Statistics Cards Grid */}
          <div className="about-stats-grid" data-aos="fade-up" data-aos-delay="150">
            {displayStats.map((item) => (
              <div className="rich-stat-card" key={item.id}>
                <div className="stat-icon-container">{getStatIcon(item.name)}</div>

                <div
                  style={{
                    fontSize: "2.25rem",
                    fontWeight: "800",
                    color: theme.primary,
                    marginBottom: "6px",
                  }}
                >
                  <CountUp end={Number(item.count) || 0} duration={2.5} />+
                </div>

                <div
                  style={{
                    fontSize: "0.925rem",
                    fontWeight: "600",
                    color: theme.textMuted,
                    textTransform: "capitalize",
                  }}
                >
                  {item.name}
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}